// Angular imports
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// CC-Common imports
import { DateUtils, IconConstants, Utils } from 'cc-common';

// Third party imports
import { DxFormComponent } from 'devextreme-angular';

// Constant imports
import { Constants } from '../../../_constants/constants';

// Service imports
import { PrecisionService } from '../../../_services/shared-services/precision.service';

// Model imports
import { AccAllowanceSubCategoryResultDto } from '../../_models/acc-allowance-sub-category-result-dto';
import { AccEditorResultDto } from '../../_models/acc-editor-result-dto';
import { AccItemRawDto } from '../../_models/acc-item-raw-dto';

@Component({
    selector: 'app-line-item-form-editor',
    templateUrl: './line-item-form-editor.component.html',
    styleUrls: ['./line-item-form-editor.component.scss']
})
export class LineItemFormEditorComponent implements OnInit {
    @ViewChild('formEditor', { static: false }) formEditor: DxFormComponent;
    @Input() visible: boolean;
    @Input() editorData: AccEditorResultDto = new AccEditorResultDto();
    @Input() editlineItem: AccItemRawDto = new AccItemRawDto();

    @Output() onLineItemAdd = new EventEmitter<AccItemRawDto>();
    @Output() onClose = new EventEmitter<void>();

    defaultLabelLocation = Constants.defaultFormLabelLocation;
    currencyFormat: any;
    lineItem: AccItemRawDto = new AccItemRawDto();
    allowanceSubCategory: Array<AccAllowanceSubCategoryResultDto> = [];
    today = new Date();

    iconClose = IconConstants.CLOSE;
    iconCheck = IconConstants.CHECK;

    popupTitle: string;

    constructor(private readonly precisionService: PrecisionService) {
        this.currencyFormat = this.precisionService.getCurrencyFormat();
    }

    ngOnInit() {
        this.lineItem.dueDate = Utils.notNullAndDefined(this.editorData.defaultDueDate)
            ? this.editorData.defaultDueDate
            : this.today;
        this.onDueDateValueChange();

        if (Utils.notNullAndDefined(this.editlineItem.id)) {
            this.popupTitle = 'Edit Form';
            this.lineItem = this.editlineItem;
        } else {
            this.popupTitle = 'Add Form';
        }
    }

    onDueDateValueChange(): void {
        this.lineItem.daysRemaining = DateUtils.differenceInDays(this.today, this.lineItem.dueDate);
    }

    onClosePopup(): void {
        this.visible = false;
        this.onClose.emit();
    }

    onOkClick(): void {
        const validator = this.formEditor.instance.validate();
        if (Utils.isTrue(validator.isValid)) {
            if (Utils.notNullAndDefined(this.lineItem.accItemId)) {
                this.lineItem.crudAction = 'Edit';
            } else {
                this.lineItem.crudAction = 'Add';
            }
            this.onLineItemAdd.emit(this.lineItem);
            this.visible = false;
        }
    }

    onStartDateChanged(): void {
        this.lineItem.allowanceEndDate = null;
    }

    onAllowanceCategoryChanged(): void {
        this.allowanceSubCategory = this.editorData.allowanceSubCategory.filter((d) =>
            Utils.equals(d.allowanceCategoryId, this.lineItem.allowanceCategoryId)
        );
    }

    onStatusChanged(): void {
        // NOTE: As per ASP.net => If status === Submitted to Committee then set today's date to Committee Submitted Date
        if (Utils.equals(this.lineItem.statusId, 2)) {
            this.lineItem.committeeSubmittedDate = new Date();
        } else {
            this.lineItem.committeeSubmittedDate = null;
        }
    }
}
